const baseURL = process.env.baseURL;
localStorage.baseURL=baseURL
export const apiUtil = {
  "getByPage" : baseURL+"manager/announcement/getByPage",
  "getAppVersion" : baseURL+"manager/setting/setting/get/APP_VERSION",
}



// WEBPACK FOOTER //
// ./src/request/api.js